import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import CTASection from '../components/CTASection';
import { CheckCircle2, ArrowLeft, Building } from 'lucide-react';

const ServiceDetail = () => {
  const { slug } = useParams();
  const { t } = useLang();
  const service = t.services.list.find(s => s.slug === slug);
  if (!service) return <div className="sib-container py-20"><p>Service not found. <Link to="/services" className="text-[#0B5D3B] underline">Back to services</Link></p></div>;

  return (
    <div>
      <section className="hero-green text-white">
        <div className="sib-container py-16 md:py-20">
          <Link to="/services" className="inline-flex items-center gap-2 text-[#D4A840] text-sm mb-6 hover:text-white"><ArrowLeft size={16} className="rtl-flip" />{t.nav.services}</Link>
          <div className="eyebrow text-[#D4A840] mb-3">{t.services.title}</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" style={{fontFamily:"'Playfair Display',serif"}}>{service.title}</h1>
          <p className="text-white/85 text-lg max-w-3xl">{service.short}</p>
        </div>
      </section>
      <section className="bg-white py-16">
        <div className="sib-container grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <h2 className="text-2xl md:text-3xl font-bold text-[#0B5D3B] mb-4">Overview</h2>
            <p className="text-[#33473d]/85 leading-relaxed mb-8">{service.long}</p>
            <h3 className="text-xl font-semibold text-[#0B5D3B] mb-4">What's Included</h3>
            <ul className="space-y-3">
              {service.features.map((f, i) => (
                <li key={i} className="flex items-start gap-3 text-[#33473d]"><CheckCircle2 className="w-5 h-5 text-[#D4A840] mt-0.5 flex-shrink-0" /><span>{f}</span></li>
              ))}
            </ul>
          </div>
          <aside className="bg-[#FBF9F2] border border-[#E8E1CE] rounded-lg p-6 h-fit sticky top-28">
            <div className="w-11 h-11 rounded-md bg-[#0B5D3B] flex items-center justify-center mb-4"><Building className="w-5 h-5 text-[#D4A840]" /></div>
            <h4 className="font-semibold text-[#0B5D3B] mb-3">Other Services</h4>
            <ul className="space-y-2">
              {t.services.list.filter(s => s.slug !== slug).slice(0,6).map(s => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-sm text-[#33473d] hover:text-[#0B5D3B] hover:underline">{s.title}</Link></li>
              ))}
            </ul>
          </aside>
        </div>
      </section>
      <CTASection serviceName={service.title} />
    </div>
  );
};
export default ServiceDetail;
